<div
  class="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-cover bg-center"
  style="background-image: url('/login_background1.jpg')"
>
  <div class="pointer-events-none absolute inset-0 bg-slate-900/72"></div>

  <div class="relative z-10 flex w-full flex-col items-center px-4">
    <img class="mb-8 h-10 w-auto" src="/Aksia_Logo_white.png" alt="Aksia" />

    @if (auth.statusMessage()) {
      <p class="mb-4 text-sm text-rose-300">{{ auth.statusMessage() }}</p>
    }

    @if (activationKind()) {
      <p class="max-w-sm text-center text-sm text-white/80">
        @if (activationKind() === 'setup') {
          <span class="font-medium text-white"
            >Set your password to continue.</span
          >
          We've upgraded Aksia's sign-in and your previous password wasn't
          carried over.
        } @else {
          <span class="font-medium text-white"
            >Your password must be updated before you can sign in.</span
          >
          Your administrator has asked you to choose a new one.
        }
      </p>

      <p class="mt-3 max-w-sm text-center text-sm text-white/80">
        @if (sendingActivationLink()) {
          Sending you a link…
        } @else if (activationLinkState() === 'sent') {
          We have sent a link to
          <span class="font-medium text-white">{{
            activationEmail() ?? 'your registered email address'
          }}</span
          >, valid for {{ resetLinkValidMinutes }} minutes.
        } @else if (activationLinkState() === 'throttled') {
          Too many requests. Please wait a few minutes before asking for another
          link.
        } @else if (activationLinkState() === 'failed') {
          We couldn't send the link just now. Please try again.
        }
      </p>

      <button
        type="button"
        class="mt-5 rounded-lg bg-slate-100/95 px-6 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
        [disabled]="sendingActivationLink()"
        (click)="sendActivationLink()"
      >
        Resend link
      </button>

      <div class="mt-5 flex gap-6 text-xs text-white/75">
        <button
          type="button"
          class="transition hover:text-white"
          (click)="leaveActivation()"
        >
          Back to sign in
        </button>
        <a class="transition hover:text-white" href="mailto:support@aksia.com">
          Contact support
        </a>
      </div>
    } @else {
      <form (submit)="submit($event)" novalidate>
        <div
          class="flex rounded-lg overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.4)]"
          [class.form-shake]="formShaking()"
        >
          @if (!isTwoFactorStep()) {
            <div class="flex flex-col bg-white/95">
              <input
                class="w-60 border-0 border-b border-slate-200 bg-transparent px-3 py-2.5 text-sm text-slate-900 outline-none placeholder:text-slate-400"
                style="
                  transition:
                    border-bottom-color 200ms ease,
                    border-bottom-width 150ms ease;
                "
                [style.borderBottomColor]="
                  showFieldError('username') || showFieldError('password')
                    ? '#c0392b'
                    : undefined
                "
                [style.borderBottomWidth]="
                  showFieldError('username') || showFieldError('password')
                    ? '2px'
                    : undefined
                "
                type="text"
                autocomplete="username"
                placeholder="Username"
                maxlength="32"
                [value]="credentials().maxusername || ''"
                (input)="updateUsername($any($event.target).value)"
                (blur)="usernameTouched.set(true)"
              />
              <input
                class="w-60 border-0 bg-transparent px-3 py-2.5 text-sm text-slate-900 outline-none placeholder:text-slate-400"
                [type]="passwordVisibility() ? 'text' : 'password'"
                autocomplete="current-password"
                placeholder="Password"
                maxlength="64"
                [value]="credentials().maxpassword || ''"
                (input)="updatePassword($any($event.target).value)"
                (blur)="passwordTouched.set(true)"
              />
            </div>
          } @else {
            <div class="flex flex-col bg-white/95">
              <input
                class="w-60 border-0 bg-transparent px-3 py-5 text-center text-lg tracking-[0.4em] text-slate-900 outline-none placeholder:tracking-normal placeholder:text-slate-400"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                placeholder="000000"
                maxlength="6"
                [value]="credentials().IPVerificationCode || ''"
                (input)="updateVerificationCode($any($event.target).value)"
              />
            </div>
          }

          <button
            class="border-l border-slate-200 bg-slate-100/95 px-5 text-sm font-medium text-slate-700 whitespace-nowrap transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
            type="submit"
            [disabled]="signInIsDisabled()"
          >
            @if (showLoader()) {
              <span
                class="block h-4 w-4 animate-spin rounded-full border-2 border-slate-400/30 border-t-slate-600"
              ></span>
            } @else {
              {{ btnTitle() }}
            }
          </button>
        </div>

        @if (
          showFieldError('username') ||
          showFieldError('password') ||
          showFieldError('code')
        ) {
          <p class="mt-2 text-center text-xs text-rose-300">
            Please fill in all required fields.
          </p>
        }

        @if (!isTwoFactorStep()) {
          <div
            class="mt-3 flex items-center justify-between text-xs text-white/75"
          >
            <label class="flex cursor-pointer items-center gap-2">
              <input
                class="h-3.5 w-3.5 cursor-pointer accent-slate-300"
                type="checkbox"
                [checked]="rememberMe()"
                (change)="rememberMe.set($any($event.target).checked)"
              />
              <span>Remember me</span>
            </label>
            <button
              type="button"
              class="transition hover:text-white"
              (click)="goToForgotPassword()"
            >
              Forgot Your Password?
            </button>
          </div>
        }
      </form>
    }
  </div>

  <footer
    class="absolute bottom-0 w-full py-4 text-center text-xs text-white/40"
  >
    <a class="transition hover:text-white/70" href="mailto:support@aksia.com">
      Contact support
    </a>
  </footer>
</div>
